import React from 'react'
import JobStateStatus from '../JobStateStatus'
import GoToSampleDashboard from './GoToSampleDashboard'
import { getStatusLabel } from '../utils/fileUtils'

const SEQUENCE_FILE_TYPES = ['fastq', 'ont_bam', 'pacbio_bam']

const DashboardDisplay = React.memo(({ row }) => {
  const status = getStatusLabel(row)

  if (status !== 'DONE' && status !== 'PENDING') {
    return <JobStateStatus status={status} />
  }

  // ONT BAM files: vcf_id may not be available until pipeline generates a VCF
  const fileId = row.vcf_id
  if (!fileId) {
    return <JobStateStatus status={status} />
  }

  // The QC dashboard exists for FASTQ, ONT and PacBio only; a VCF upload has
  // no QC run (same rule as the Home table).
  if (!SEQUENCE_FILE_TYPES.includes(row.file_type)) return null

  return (
    <GoToSampleDashboard
      fileId={fileId}
      sampleName={row.sample_name}
      fastqPairId={row.fastq_pair_id ? row.fastq_pair_id : null}
    />
  )
})

DashboardDisplay.displayName = 'DashboardDisplay'

export default DashboardDisplay
